const TRIGGER_SELECTOR = '[data-order-action-trigger]';
const ACTIVE_CLASS = 'active';

class OrderActions {
  constructor(wrapper) {
    this.wrapper = wrapper;
    this.triggers = this.wrapper.querySelectorAll(TRIGGER_SELECTOR);
    this.bindEvents();
  }

  bindEvents() {
    Array.prototype.forEach.call(this.triggers, trigger => {
      let target = document.querySelector(trigger.getAttribute('href'));
      if (!target) {
        return;
      }
      trigger.addEventListener('click', event => {
        event.preventDefault();
        this.toggleActive(target);
      });
    });
  }

  toggleActive(element) {
    element.classList.toggle(ACTIVE_CLASS);
  }
}

export default OrderActions;



// WEBPACK FOOTER //
// ./src/javascripts/OrderActions.js